/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
/* eslint-disable new-cap */
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const downloadPDF = async ({ name }: { name: string }) => {
  const input: any = document.getElementById('invoice_print');
  html2canvas(input).then(async (canvas) => {
    const imgData = canvas.toDataURL('image/png', 1.0);
    const pdf = new jsPDF('p', 'px', 'a4');
    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;

    const widthRatio = pageWidth / canvas.width;
    const heightRatio = pageHeight / canvas.height;
    const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

    const canvasWidth = canvas.width * ratio;
    const canvasHeight = canvas.height * ratio;

    const marginX = (pageWidth - canvasWidth) / 2;
    const marginY = (pageHeight - canvasHeight) / 2;

    pdf.addImage(imgData, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
    pdf.save(`Invoice-${name}.pdf`);
  });
};

export class FileService {
  /**
   * Downloads a PDF file from a Blob.
   * @param blob - The Blob containing the PDF file.
   * @param fileName - The name of the file to download.
   */
  static downloadBlobPDF(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
